module.exports = __webpack_public_path__ + "fonts/f3a02e2578bee50e620e515912278bc9-Roboto-Bold.woff2";